import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../css/table.css";
import { useNavigate } from "react-router-dom";

function Table() {
  const navigate = useNavigate();   // 👈 ADD THIS
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get("http://localhost:5000/get-users");
      setUsers(res.data);   // pura array ek saath set hoga
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  if (loading) {
    return <h2 style={{ textAlign: "center" }}>Loading...</h2>;
  }

  return (
    <section className="cursed-table-section">
      <h2 className="table-title">Registered Souls</h2>

      <div
        className="back-to-form"
        onClick={() => navigate("/form")}
      >
        Return to the Form →
      </div>

      <div className="table-wrapper">
        <table className="cursed-table">
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>DOB</th>
              <th>Address</th>
              <th>Pincode</th>
            </tr>
          </thead>

          <tbody>
            {users.length > 0 ? (
              users.map((item) => (
                <tr key={item._id}>
                  <td>{item.firstName}</td>
                  <td>{item.lastName}</td>
                  <td>{item.email}</td>
                  <td>{item.date}</td>
                  <td>{item.address}</td>
                  <td>{item.pincode}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="no-data">
                  No data found...
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default Table;